export default function Hero() {
  return (
    <>
      <section className="hero" id="hero">
        <img
          src="/assets/website/images/pattern-dots.svg"
          className="hero-pattern"
          alt=""
          aria-hidden="true"
        />
        <div className="container hero-inner">
          <div className="hero-copy">
            <p className="eyebrow">🚕 Now live in 120+ cities</p>
            <h1>
              Where are <span className="accent-text">you</span> headed?
            </h1>
            <p className="hero-sub">
              Book a full cab or just the seats you need for your next intercity
              trip — fixed routes, fixed fares, zero surge pricing.
            </p>
            <div className="hero-stats">
              <div>
                <strong id="statRiders">52,000+</strong>
                <span>Happy riders</span>
              </div>
              <div>
                <strong id="statDrivers">640+</strong>
                <span>Verified drivers</span>
              </div>
              <div>
                <strong id="statCities">120+</strong>
                <span>Cities connected</span>
              </div>
              <div>
                <strong>4.8★</strong>
                <span>Average rating</span>
              </div>
            </div>
          </div>
          <div className="search-card" id="searchCard">
            <div className="search-tabs">
              <button
                className="search-tab active"
                data-tab="per-seat"
                type="button"
              >
                🧑‍🤝‍🧑 Per-Seat Sharing
              </button>
              <button className="search-tab" data-tab="full-cab" type="button">
                🚙 Full Cab
              </button>
            </div>
            <form className="search-form" id="searchForm">
              <div className="field-row">
                <div className="field">
                  <label htmlFor="fromCity">From</label>
                  <select id="fromCity" required="">
                    <option value="">Select city</option>
                    <option>Lucknow</option>
                    <option>Kanpur</option>
                    <option>Delhi</option>
                    <option>Agra</option>
                    <option>Jaipur</option>
                    <option>Varanasi</option>
                    <option>Prayagraj</option>
                    <option>Noida</option>
                  </select>
                </div>
                <button
                  type="button"
                  className="swap-btn"
                  id="swapBtn"
                  aria-label="Swap cities"
                >
                  ⇅
                </button>
                <div className="field">
                  <label htmlFor="toCity">To</label>
                  <select id="toCity" required="">
                    <option value="">Select city</option>
                    <option>Kanpur</option>
                    <option>Lucknow</option>
                    <option>Delhi</option>
                    <option>Agra</option>
                    <option>Jaipur</option>
                    <option>Varanasi</option>
                    <option>Prayagraj</option>
                    <option>Noida</option>
                  </select>
                </div>
              </div>
              <div className="field-row">
                <div className="field">
                  <label htmlFor="travelDate">Travel date</label>
                  <input
                    type="date"
                    id="travelDate"
                    required=""
                    min="2026-08-07"
                  />
                </div>
                <div className="field">
                  <label htmlFor="passengers">Passengers</label>
                  <select id="passengers">
                    <option>1</option>
                    <option selected="">2</option>
                    <option>3</option>
                    <option>4</option>
                    <option>5</option>
                    <option>6</option>
                  </select>
                </div>
              </div>
              <button type="submit" className="btn btn-block btn-white">
                Search Cabs →
              </button>
              <p className="form-note" id="formNote" />
            </form>
          </div>
        </div>
      </section>
    </>
  );
}
